import HomeIndex from './home';

export default HomeIndex;
